import React from 'react';
import { Droplet, SunDim } from 'lucide-react';

const ReflectionCoefficientsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Droplet className="w-5 h-5 mr-2 text-blue-500" />
        Коэффициенты отражения поверхностей
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3">
        {/* Коэффициент отражения потолка */}
        <div>
          <label htmlFor="reflectionCeiling" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Потолок
          </label>
          <select
            id="reflectionCeiling"
            name="reflectionCeiling"
            value={formData.reflectionCeiling}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.reflectionCeiling ? 'input-error' : ''}`}
          >
            <option value="0.8">0.80 - Белый потолок (новый)</option>
            <option value="0.7">0.70 - Белый потолок (стандартный)</option>
            <option value="0.5">0.50 - Светлый потолок</option>
            <option value="0.3">0.30 - Потолок средней тональности</option>
            <option value="0.1">0.10 - Темный потолок</option>
          </select>
          {errors.reflectionCeiling && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.reflectionCeiling}
            </p>
          )}
        </div>

        {/* Коэффициент отражения стен */}
        <div>
          <label htmlFor="reflectionWalls" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Стены
          </label>
          <select
            id="reflectionWalls"
            name="reflectionWalls"
            value={formData.reflectionWalls}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.reflectionWalls ? 'input-error' : ''}`}
          >
            <option value="0.8">0.80 - Белые стены (новые)</option>
            <option value="0.7">0.70 - Белые стены</option>
            <option value="0.5">0.50 - Светлые стены (стандартные)</option>
            <option value="0.3">0.30 - Стены средней тональности</option>
            <option value="0.1">0.10 - Темные стены</option>
          </select>
          {errors.reflectionWalls && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.reflectionWalls}
            </p>
          )}
        </div>

        {/* Коэффициент отражения пола */}
        <div>
          <label htmlFor="reflectionFloor" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Пол
          </label>
          <select
            id="reflectionFloor"
            name="reflectionFloor"
            value={formData.reflectionFloor}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.reflectionFloor ? 'input-error' : ''}`}
          >
            <option value="0.4">0.40 - Светлый пол</option>
            <option value="0.3">0.30 - Пол средней тональности (стандартный)</option>
            <option value="0.2">0.20 - Темный пол</option>
            <option value="0.1">0.10 - Очень темный пол</option>
          </select>
          {errors.reflectionFloor && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.reflectionFloor}
            </p>
          )}
        </div>
      </div>

      {/* Информация о коэффициентах */}
      <div className="bg-blue-100 dark:bg-blue-900/40 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start gap-2">
          <SunDim className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">О коэффициентах отражения</h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Коэффициенты отражения показывают, какую часть света поверхность отражает. 
              Светлые поверхности отражают больше света, что улучшает освещение и позволяет 
              использовать меньше светильников. По СП 52.13330.2016, рекомендуемые коэффициенты: 
              потолок - 0.7-0.8, стены - 0.5-0.7, пол - 0.2-0.3.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReflectionCoefficientsSection;